import React from 'react';

const DonutChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path fill="#3B82F6" d="M40 8a20 20 0 0 1 11.76 36.18l-5.29-7.28A11 11 0 0 0 40 17z"></path>
      <path
        fill="#818CF8"
        d="M51.76 44.18a20 20 0 0 1-29.86-7.66l8.15-3.84a11 11 0 0 0 16.42 4.22z"
      ></path>
      <path
        fill="#38BDF8"
        d="M21.9 36.52a20 20 0 0 1 4.41-23.1l6.16 6.56a11 11 0 0 0-2.42 12.7z"
      ></path>
      <path fill="#A5B4FC" d="M26.31 13.42A20 20 0 0 1 40 8v9a11 11 0 0 0-7.53 2.98z"></path>
    </svg>
  );
};

export default DonutChartIcon;
